import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import "./authTitle.scss";

const messages = defineMessages({
  logInToNateraTitle: {
    id: "logInToNateraTitle",
    defaultMessage: "Log in to Natera’s Patient Portal",
  },
});

type AuthTitleProps = {
  title?: string;
  subtitle?: string;
  isRedirectPage?: boolean;
};

export const AuthTitle: FC<AuthTitleProps> = ({
  title,
  subtitle,
  isRedirectPage,
}) => {
  const intl = useIntl();

  const authTitle = title
    ? title
    : intl.formatMessage(messages.logInToNateraTitle);

  return (
    <div className={isRedirectPage ? "auth-title--redirect" : "auth-title"}>
      <h1>{authTitle}</h1>
      {subtitle && <span>{subtitle}</span>}
    </div>
  );
};
